import {
  Box,
  Typography,
  Link as MuiLink,
  TextField,
  Button,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "#d4b483" },
    "&:hover fieldset": { borderColor: "#b68a58" },
    "&.Mui-focused fieldset": { borderColor: "#b68a58" },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: "#b68a58" },
};

const Contacts = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState<
    "idle" | "sending" | "success" | "error"
  >("idle");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("sending");
    try {
      await fetch("https://formsubmit.co/ajax/Woskennel@gmail.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          message: form.message,
          _subject: `New contact from ${form.name}`,
          _captcha: "false",
        }),
      });
      setStatus("success");
      setForm({ name: "", email: "", message: "" });
    } catch {
      setStatus("error");
    }
  };

  return (
    <Box className="article-main">
      <Typography
        variant="h4"
        sx={{
          fontFamily: '"Cinzel", serif',
          color: "#4a3728",
          borderBottom: "2px solid #d4b483",
          pb: 1,
          mb: 3,
        }}
      >
        Contacts
      </Typography>

      <Typography
        variant="h6"
        sx={{ fontFamily: '"Cinzel", serif', color: "#4a3728", mb: 2 }}
      >
        Send us a message
      </Typography>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: 600 }}
      >
        <TextField
          label="Your Name"
          name="name"
          value={form.name}
          onChange={handleChange}
          required
          fullWidth
          sx={fieldSx}
        />
        <TextField
          label="Your Email"
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          required
          fullWidth
          sx={fieldSx}
        />
        <TextField
          label="Message"
          name="message"
          value={form.message}
          onChange={handleChange}
          required
          fullWidth
          multiline
          rows={5}
          sx={fieldSx}
        />

        {status === "success" && (
          <Alert severity="success">
            Your message has been sent! We'll get back to you soon.
          </Alert>
        )}
        {status === "error" && (
          <Alert severity="error">
            Something went wrong. Please try again or email us directly.
          </Alert>
        )}

        <Button
          type="submit"
          variant="contained"
          disabled={status === "sending"}
          sx={{
            alignSelf: "flex-start",
            fontFamily: '"Cinzel", serif',
            backgroundColor: "#b68a58",
            color: "#fff",
            px: 4,
            py: 1.2,
            textTransform: "uppercase",
            letterSpacing: 1,
            "&:hover": { backgroundColor: "#9a7348" },
            "&:disabled": { backgroundColor: "#d4c4a8" },
          }}
        >
          {status === "sending" ? (
            <CircularProgress size={22} sx={{ color: "#fff" }} />
          ) : (
            "Send Message"
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default Contacts;
